import { createContext } from 'react';
import { Config } from '@common/Config/types';

const configContext = createContext(<Config>({} as Config));
configContext.displayName = 'ConfigContext';

export default configContext;
